module.exports = __webpack_public_path__ + "static/media/listing-banner-fara-rabla.244cd2c4.jpg";